<template>
    <div class="all-games-table-container">
        <sidebar
            :sidebar-dashboard="true"
            class="all-games-table-container__sidebar"
        ></sidebar>
        <creator-name
            class="all-games-table-container__creator-name"
        ></creator-name>

        <div class="all-games-table-container__summary-table">
            <div class="return">
                <button-back class="return__button-return"></button-back>
            </div>
            <div v-if="!getLoading" class="summary-table-container">
                <div class="summary-data-table__title">Games hosted by me</div>
                <div class="summary-data-table">
                    <Table
                        :columns="columns"
                        :data="getGames ? getGames : null"
                        :cell-style="
                            'display: grid; grid-template-columns: 2fr 2fr 2fr 2fr 0.7fr; grid-template-rows: 4rem;'
                        "
                        :data-elements="[
                            'name',
                            'currentPlayers',
                            'allServersCount',
                            'scenarioEarning',
                        ]"
                        :cropp="true"
                        :cropp-no="10"
                        :footer-elements="
                            getGames && getGames.length > 0
                                ? [
                                      'Total',
                                      `${totalCurrentPlayers}`,
                                      `${allServersCount}`,
                                      `${total_coyns_earned}`,
                                  ]
                                : null
                        "
                        :is-loading="getLoading"
                        :no-title="true"
                    />
                </div>
            </div>
            <loading-table v-else></loading-table>
        </div>
    </div>
</template>

<script>
import LoadingTable from '@/components/common/loading/LoadingTable';
import { totalNumber } from '@/lib/calculations.js';
import { croppName } from '@/lib/croppName.js';
import { mapActions, mapGetters } from 'vuex';
import Sidebar from '@/components/sidebar/index';
import CreatorName from '@/components/dashboard/sections/DashboardCreatorName';
import ButtonBack from '@/components/common/ButtonBack.vue';
import Table from '@/components/common/Table.vue';

export default {
    name: 'AllGamesHostedByMe',
    components: {
        LoadingTable,
        Sidebar,
        CreatorName,
        ButtonBack,
        Table,
    },
    data() {
        return {
            veryDarkBlueButton: {
                backgroundColor: '#0a294a',
                border: '2px solid #0a294a',
                width: '94px',
                height: '29px',
                borderRadius: '6px',
                padding: '0',
                color: '$white-main',
                fontFamily: '$palanquin-font',
                fontSize: '13px',
                fontWeight: '400',
                letterSpacing: '0.05px',
                margin: '6rem 5rem auto auto',
            },
            columns: [
                'Game name',
                'Current Players',
                'Servers',
                'Coyns Earned',
            ],
        };
    },
    computed: {
        ...mapGetters('module_servers', {
            getLoading: 'getLoading',
            getGames: 'getGames',
            allServersCount: 'allServersCount',
            totalCurrentPlayers: 'totalCurrentPlayers',
        }),

        total_coyns_earned() {
            return totalNumber(this.getGames, 'scenarioEarning');
        },
    },
    created: function() {
        this.fetchServers();
    },

    methods: {
        croppName,
        totalNumber,
        ...mapActions('module_servers', ['fetchServers']),
    },
};
</script>

<style scoped lang="scss">
.all-games-table-container {
    @include main-grid-container;
    height: 100%;

    @media (max-width: $lg-up) {
        padding-top: 10%;
    }
    @media (max-width: $md-up) {
        padding-top: 15%;
    }
    @media (max-width: $sm-up) {
        padding-top: 20%;
    }
    &__sidebar {
        grid-column: col-start / span 3;
        grid-row: auto;
        height: 100%;
    }
    &__creator-name {
        grid-column: col-start 4 / 13;
        grid-row: 1;
        @media (max-width: $sm-up) {
            grid-column: col-start / 13;
            margin-top: 3rem;
        }
    }
    &__summary-table {
        margin-top: -730px;
        grid-column: col-start 4 / 13;
        grid-row: 3;
        background: $white-main;
        height: 100%;

        .return {
            padding-top: 20px;
            padding-left: 50px;
            padding-bottom: 5px;

            @media (max-width: $xs-up) {
                padding-left: 20px;
            }
        }

        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin-top: 0;
        }
    }
}
.summary-table-container {
    .summary-data-table {
        position: static;
        margin-bottom: 200px;
        right: 0;
        overflow-x: auto;

        width: 90%;
        margin-left: 2rem;
        &__title {
            margin: 2rem auto 2rem 4rem;
            color: $blue-main;
            font-family: $istok-font;
            font-size: 36px;
            font-weight: 700;
            letter-spacing: 0.57px;
            line-height: 53px;

            @media (max-width: 768px) {
                margin-left: 3rem;
            }

            @media (max-width: 414px) {
                width: 90%;
                margin: 2rem auto 2rem auto;
            }
            @media (max-width: 360px) {
                width: 100%;
                margin: 2rem auto 2rem auto;
                text-align: center;
                font-size: 30px;
            }
        }
    }
}
</style>
<style lang="scss">
.summary-data-table {
    margin: 1rem auto auto 0;
    width: 90%;

    @media (max-width: $xs-up) {
        margin: auto;
        width: 90%;
    }
    .generic-table {
        .cont {
            @media (max-width: $xs-up) {
                width: 700px;
            }
        }
    }
}
</style>
